import { createSlice } from '@reduxjs/toolkit';
import {
  getProducts,
  deleteProduct,
  addProduct,
  updateProduct,
  getProductByID,
  importProducts
} from './productsThunk';

const initialState = {
  products: {
    data: [],
    loading: false,
    error: null,
  },
  importProducts: {
    data: null,
    loading: false,
    error: null,
  },
  deletedProduct: {
    data: null,
    loading: false,
    error: null,
  },
  product: {
    data: null,
    loading: false,
    error: null
  },
  updatedProduct: {
    data: null,
    loading: false,
    error: null
  },
  productByID: {
    data: null,
    loading: false,
    error: null
  }
};

const productsSlice = createSlice({
  name: 'products',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getProducts.pending, (state) => {
        state.products.loading = true;
        state.error = null;
      })
      .addCase(getProducts.fulfilled, (state, action) => {
        state.products = action.payload;
        state.products.loading = false;
      })
      .addCase(getProducts.rejected, (state, action) => {
        state.products.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteProduct.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteProduct.fulfilled, (state, action) => {
        state.deletedProduct = action.payload;
        state.loading = false;
      })
      .addCase(deleteProduct.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(addProduct.pending, (state) => {
        state.product.loading = true;
        state.product.error = null;
      })
      .addCase(addProduct.fulfilled, (state, action) => {
        state.product.data = action.payload;
        state.product.loading = false;
      })
      .addCase(addProduct.rejected, (state, action) => {
        state.product.loading = false;
        state.product.error = action.payload;
      })
      .addCase(updateProduct.pending, (state) => {
        state.updatedProduct.loading = true;
        state.updatedProduct.error = null;
      })
      .addCase(updateProduct.fulfilled, (state, action) => {
        state.updatedProduct.data = action.payload;
        state.updatedProduct.loading = false;
      })
      .addCase(updateProduct.rejected, (state, action) => {
        state.updatedProduct.loading = false;
        state.updatedProduct.error = action.payload;
      })
      .addCase(getProductByID.pending, (state) => {
        state.productByID.loading = true;
        state.productByID.error = null;
      })
      .addCase(getProductByID.fulfilled, (state, action) => {
        state.productByID.data = action.payload;
        state.productByID.loading = false;
      })
      .addCase(getProductByID.rejected, (state, action) => {
        state.productByID.loading = false;
        state.productByID.error = action.payload;
      })
      .addCase(importProducts.pending, (state) => {
        state.importProducts.loading = true;
        state.importProducts.error = null;
      })
      .addCase(importProducts.fulfilled, (state, action) => {
        state.importProducts.data = action.payload;
        state.importProducts.loading = false;
      })
      .addCase(importProducts.rejected, (state, action) => {
        state.importProducts.loading = false;
        state.importProducts.error = action.payload;
      })
  },
});

export default productsSlice.reducer;
